import * as React from 'react';

import { BaseComponent } from './BaseComponent';

interface CustomRadioGroupProps extends React.Props<CustomRadioGroup> {
    label?: string;
    values: Array<{ label: string, value: string }>;
    defaultValue?: string;
    onChange: (option: string) => void;
    disabled?: boolean;
    type?: 'radio' | 'checkbox';
}

interface CustomRadioGroupState {
    value: string | undefined;
}

export class CustomRadioGroup extends BaseComponent<CustomRadioGroupProps, CustomRadioGroupState> {
    public componentWillMount(): void {
        this.onChange();
    }

    public render(): React.ReactElement<CustomRadioGroupProps> {
        return (
            <div className="input-container custom-radio-group">
                {this.props.label &&
                    <div className="custom-radio-group__label">{this.props.label}</div>}
                {this.props.values.map((value: { label: string, value: string }, index: number) => {
                    let tClass: string = 'custom-radio-group__option';
                    if (this.props.type === 'checkbox') {
                        tClass += ' custom-radio-group__option--checkbox';
                    }
                    if (this.state.value === value.value) {
                        tClass += ' custom-radio-group__option--checked';
                    }
                    if (this.props.disabled) {
                        tClass += ' custom-radio-group__option--disabled';
                    }
                    return (
                        <div className={tClass} key={index} onClick={this.onClick(value.value)}>
                            <span>{value.label}</span>
                        </div>
                    );
                })}
            </div>
        );
    }

    protected onChange = (): void => {
        this.setState({
            value: this.props.defaultValue
        });
    };

    protected onClick = (value: string) => () => {
        if (!this.props.disabled) {
            if (this.props.type === 'checkbox' && this.state.value === value) {
                value = '';
            }
            this.setState({
                value: value
            });
            this.props.onChange(value);
        }
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/CustomRadioGroup.tsx